module.exports = __webpack_public_path__ + "static/media/IMG_0799.35d91343.jpg";